'use client'

import { useTranslation } from '@/hooks/client/use-translation'
import SvgCheck from '@/icons/thin/Check'

const FEATURE_KEYS: Array<{ key: string; fallback: string }> = [
  { key: 'captioncall.feature.touchscreen', fallback: 'High-Resolution Touchscreen' },
  { key: 'captioncall.feature.tailoring', fallback: 'Custom Audio Tailoring' },
  { key: 'captioncall.feature.compatibility', fallback: 'Hearing Aid Compatibility' },
  { key: 'captioncall.feature.speakerphone', fallback: 'Speakerphone & Voicemail' },
]

// Desktop-only feature list of the CaptionCall modal template.
export const CaptionCallFeatures = () => {
  const { t } = useTranslation()
  return (
    <div className="hidden md:block">
      <div className="text-navy mb-3 text-xs font-bold tracking-wider uppercase">
        {t('captioncall.keyFeatures', 'Key Features')}
      </div>
      <ul className="space-y-2.5">
        {FEATURE_KEYS.map(({ key, fallback }) => (
          <li key={key} className="text-base-minus flex items-center gap-2.5 font-medium text-slate-600 md:text-sm">
            <SvgCheck className="h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" />
            <span>{t(key, fallback)}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
